<form [formGroup]="form">
  <ion-list lines="full" [inset]="true" class="no-last-line">
    <ion-list-header>Your Information</ion-list-header>

    <ion-item>
      <ion-input
        redErrorMessage
        formControlName="userInformationFirstName"
        labelPlacement="stacked"
        placeholder="John"
        inputmode="text"
        type="text"
      >
        <div slot="label" class="tw:whitespace-normal">First Name</div>
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        redErrorMessage
        formControlName="userInformationLastName"
        labelPlacement="stacked"
        placeholder="Doe"
        inputmode="text"
        type="text"
      >
        <div slot="label" class="tw:whitespace-normal">Last Name</div>
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        redErrorMessage
        formControlName="userInformationPhone"
        labelPlacement="stacked"
        placeholder="555-555-5555"
        inputmode="tel"
        type="text"
        [maskito]="phoneMask"
        [maskitoElement]="maskPredicate"
      >
        <div slot="label" class="tw:whitespace-normal">Phone Number</div>
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        redErrorMessage
        formControlName="userInformationEmail"
        labelPlacement="stacked"
        placeholder="email@example.com"
        inputmode="email"
        type="email"
      >
        <div slot="label" class="tw:whitespace-normal">Email</div>
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        redErrorMessage
        formControlName="userInformationCompany"
        labelPlacement="stacked"
        placeholder="Company"
        inputmode="text"
        type="text"
      >
        <div slot="label" class="tw:whitespace-normal">Company Name</div>
      </ion-input>
    </ion-item>
  </ion-list>
</form>
